import React from 'react'

/** Full horizontal logo: orange O + blue S */
export default function BrandLogo({ className = "w-24 h-14" }: { className?: string }) {
    return (
        <svg className={className} viewBox="0 0 96 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Orange O */}
            <circle cx="24" cy="28" r="16" stroke="#EF7F1A" strokeWidth="8" />
            {/* Blue S */}
            <path
                d="M66 14C63 13 60 12.5 57 13C50 14.5 49 20 49 23C49 28.5 64 29.5 64 35C64 39.5 59.5 42 56 42C51.5 42 48.5 40 47 38.5"
                stroke="#0072BC" strokeWidth="8" strokeLinecap="round"
            />
        </svg>
    )
}

/** Compact square icon — used in sidebar, favicons, tabs */
export function BrandLogoIcon({ className = "w-8 h-8" }: { className?: string }) {
    return (
        <svg className={className} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Dark background pill */}
            <rect width="44" height="44" rx="10" fill="#001529" />
            {/* Orange O */}
            <circle cx="14" cy="22" r="8" stroke="#EF7F1A" strokeWidth="4" />
            {/* Blue S */}
            <path
                d="M31 13.5C29.5 13 28 12.5 26.5 13C23 14 22 17 22 19C22 22.5 30 23 30 26.5C30 29 27.5 30.5 26 30.5C24 30.5 22.5 29.5 21.5 28.5"
                stroke="#0072BC" strokeWidth="4" strokeLinecap="round"
            />
        </svg>
    )
}
